/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { Row, Spin, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PackageService } from '@/services';
import { useBeforeRender } from '@/hooks/useBeforeRender';
import { ROUTES } from '@/constants';
import CurrentPlan from '@/containers/Subscription/List/CurrentPlan';
import CreditLogTable from '@/components/CreditLogTable';

import './index.scss';

function Subscriptions() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [currentData, setCurrentData] = useState();
  const [bestPlan, setBestPlan] = useState();
  const navigate = useNavigate();
  const fetchData = async () => {
    const res = await PackageService.getCurrentSubscription();
    if (res.success) {
      if (!res.data?.id) {
        navigate(ROUTES.SUBSCRIPTIONS.LIST);
        return;
      }
      setCurrentData(res.data);
    }
    const { success, data: dataRes } = await PackageService.list();
    if (success) {
      const { results } = dataRes;
      setBestPlan(results.find((o) => o.isBestSeller));
    }
    setLoading(false);
  };

  useBeforeRender(() => fetchData(), []);

  return (
    <div className="subscriptions-list">
      <Spin spinning={loading || !currentData}>
        <Row gutter={[16, 24]}>
          {currentData && (
            <>
              <CurrentPlan
                plan={currentData.package}
                endTime={currentData.endTime}
                bestPlan={bestPlan}
              />
              <Col span={24}>
                <div className="plan-detail">
                  <h3 className="plan-detail__head">
                    {t('subscriptions_page.main_content.transactions.title')}
                  </h3>
                  <p
                    className="plan-detail__desc"
                    dangerouslySetInnerHTML={{
                      __html: t(
                        'subscriptions_page.main_content.transactions.description',
                        {
                          transactions_url: '/transactions',
                        },
                      ),
                    }}
                  />
                  <CreditLogTable />
                </div>
              </Col>
            </>
          )}
        </Row>
      </Spin>
    </div>
  );
}

export default Subscriptions;
